/**
 * @file reducers/PersistentPlayer/reducer.js
 * @copyright 2020 CBC/Radio-Canada. All rights reserved.
 */

import { PERSISTENT_PLAYER_HOME_SELECTOR } from "../../components/PersistentPlayer/constants";
import * as CONSTANTS from "../../actions/PersistentPlayer/constants";

export const initialState = () => ({
    isVisible: false,
    status: "",
    mediaItem: {},
    selector: PERSISTENT_PLAYER_HOME_SELECTOR,
    routeUpdate: false,
    forcePersistence: false,
    sizeConfig: {
        useMediaAspectRatio: false,
        aspectRatio: null,
    },
    mediaDataOverrides: {
        thumbnail: null,
        shouldDisableAds: false,
    },
});

export default function persistentPlayer(state = initialState(), action) {
    switch (action.type) {
        case CONSTANTS.VIDEO_PERSISTENT_PLAYER_UPDATE: {
            const persistentPlayer = action.payload;

            const routeUpdate =
                persistentPlayer.selector === PERSISTENT_PLAYER_HOME_SELECTOR
                    ? false
                    : persistentPlayer.routeUpdate;

            return { ...persistentPlayer, routeUpdate };
        }

        case CONSTANTS.VIDEO_PERSISTENT_PLAYER_NULL:
            return initialState();
        default:
            return state;
    }
}
